var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9162_37806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 9.16667H7.5C8.41667 9.16667 9.16667 8.41667 9.16667 7.5V4.16667C9.16667 3.25 8.41667 2.5 7.5 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V7.5C2.5 8.41667 3.25 9.16667 4.16667 9.16667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 17.4987H7.5C8.41667 17.4987 9.16667 16.7487 9.16667 15.832V12.4987C9.16667 11.582 8.41667 10.832 7.5 10.832H4.16667C3.25 10.832 2.5 11.582 2.5 12.4987V15.832C2.5 16.7487 3.25 17.4987 4.16667 17.4987Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 4.16667V7.5C10.8335 8.41667 11.5835 9.16667 12.5002 9.16667H15.8335C16.7502 9.16667 17.5002 8.41667 17.5002 7.5V4.16667C17.5002 3.25 16.7502 2.5 15.8335 2.5H12.5002C11.5835 2.5 10.8335 3.25 10.8335 4.16667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 17.4987H15.8335C16.7502 17.4987 17.5002 16.7487 17.5002 15.832V12.4987C17.5002 11.582 16.7502 10.832 15.8335 10.832H12.5002C11.5835 10.832 10.8335 11.582 10.8335 12.4987V15.832C10.8335 16.7487 11.5835 17.4987 12.5002 17.4987Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9162_37806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/Grid.446584b70b22c234a96f5921b816c91e.svg";
export { ForwardRef as ReactComponent };